import React from 'react';
import { bool, array, number } from 'prop-types';
import { Slider } from '@fiverr-private/orca';
import DeliveryCardPlaceholder from '../DeliveryCardPlaceholder';
import { createSliderSettings, createProjectSkeleton } from './utils';
import { DEFAULT_SLIDES_TO_SHOW } from './constants';

const DeliveriesSectionPlaceholder = ({
    slidesToShow = DEFAULT_SLIDES_TO_SHOW,
    sliderBreakpoints = [],
    isTouch = false,
    isInfinite = false,
}) => {
    const sliderSettings = createSliderSettings({
        slidesToShow,
        breakpoints: sliderBreakpoints,
        isTouch,
        isInfinite,
    });
    const items = createProjectSkeleton(slidesToShow);

    return (
        <div className="desktop-carousel loading-desktop-carousel">
            <Slider
                items={items}
                freeScroll={isTouch}
                isTouch={isTouch}
                Component={DeliveryCardPlaceholder}
                {...sliderSettings}
            />
        </div>
    );
};

DeliveriesSectionPlaceholder.propTypes = {
    isTouch: bool,
    sliderBreakpoints: array,
    slidesToShow: number,
    isInfinite: bool,
};

export default DeliveriesSectionPlaceholder;
